<div
    class="insurance-list-notice"
    *ngIf="purchasedProduct?.product?.validityStatusCode === validityStatusCodeEnum.Future"
>
    per {{ purchasedProduct?.product?.startDate | dateFormat }} -
    <span class="text--secondary">Let op: Deze verzekering is nog niet ingegaan!</span>
</div>
<div
    class="insurance-list-notice"
    *ngIf="purchasedProduct?.product?.validityStatusCode === validityStatusCodeEnum.Transfer"
>
    ingangsdatum onbekend -
    <span class="text--secondary">Let op: Deze verzekering is nog niet ingegaan!</span>
</div>
<div
    class="insurance-list-notice"
    *ngIf="
        [validityStatusCodeEnum.ActiveEnded, validityStatusCodeEnum.Ended, validityStatusCodeEnum.Disbarred].includes(
            purchasedProduct?.product?.validityStatusCode
        ) && purchasedProduct?.product?.endDate
    "
>
    tot {{ purchasedProduct?.product?.endDate | dateFormat }}
</div>
